import { convertTiptapToTemplate } from './tiptapToTemplate.ts';

// Takes the TipTap HTML output, runs the shared `convertTiptapToTemplate`
// core to swap marker spans for `{{key}}` text, then flattens paragraphs to
// newline-separated plain text — the format plain-text backends expect.
export const convertTiptapToPlainText = (tiptapHtml: string): string => {
  const htmlWithPlaceholders = convertTiptapToTemplate(tiptapHtml);

  const doc = new DOMParser().parseFromString(
    htmlWithPlaceholders,
    'text/html',
  );
  const paragraphs = Array.from(doc.body.querySelectorAll('p'));
  if (paragraphs.length === 0) return doc.body.textContent ?? '';

  return paragraphs.map((p) => p.textContent ?? '').join('\n');
};
